import { combineReducers } from 'redux';
import authReducer from './authReducer';
import teacherReducer from './teacherReducer';
import userReducer from './userReducer';
import groupReducer from './groupReducer';
import childReducer from './childReducer';
import reportReducer from './reportReducer';
import dailyReportReducer from './dailyReportReducer';
import groupReportReducer from './groupReportReducer';
import mealReducer from './mealReducer';
import attendanceReportReducer from './attendanceReportReducer';

// Import other reducers as you create them

const rootReducer = combineReducers({
  auth: authReducer,
  teacher: teacherReducer,
  users: userReducer,
  groups: groupReducer,
  children: childReducer,
  reports: reportReducer,
  dailyReport: dailyReportReducer,
  groupReports: groupReportReducer,
  meals: mealReducer,
  attendanceReport: attendanceReportReducer,
  // Add other reducers here
});

export default rootReducer;
